<template>
  <div>
    <app-overlay-loader v-if="preloader" />

    <div v-if="Object.keys(formBodies).length == 0">
          <app-empty-data-block :message="$t('nothing_to_show_message')" />
    </div>

    <div class="card card-with-shadow border-0 h-100" v-else>
      <div class="card-body">
        <form
          ref="form"
          data-url="/crud"
          class="mb-0"
          :class="{ 'loading-opacity': preloader }"
        >
          <div class="row">
            <div class="col-lg-12 col-md-12 col-sm-12">
              <!-- <label>{{ $t("bid_list")}}</label> -->
              <table class="table" >
                <tr>
                  <th>Company Name</th>
                  <th v-for="(formBody, index) in formBodies" :key="index">
                    {{ formBody.label }}
                  </th>
                  <!-- <th>Action</th> -->
                </tr>
                <tr
                  v-for="(formresponse, newIndex) in formResponses"
                  :key="newIndex"
                >
                  <template v-for="(new_res, indexName) in formresponse">
                    <td :key="indexName" v-if="indexName !== 'user_id'">
                      <p>{{ new_res }}</p>
                    </td>
                  </template>
                  <!-- <td>
                    <button class="btn btn-sm btn-success">
                      {{ formResponses[newIndex]["user_id"] }}
                    </button>
                    <button class="btn btn-sm btn-danger">Reject</button>
                  </td> -->
                </tr>
              </table>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
import { FormMixin } from "../../../../../../../core/mixins/form/FormMixin.js";
import {
  FORM_BODY,
} from "../../../../../../Config/ApiUrl.js";
import { axiosGet, axiosPost } from "../../../../../../Helpers/AxiosHelper.js";

export default {
  name: "FormGrid",
  mixins: [FormMixin],
  data() {
    return {
      preloader: true,
      formBodies: {},
      formResponses: {}, 
    };
  },
  methods: {
   
    getBodies(id) {
      // this.preloader = true;
      axiosGet(FORM_BODY + "/" + id)
        .then((res) => {
          
          let body = JSON.parse(res.data.get_revision[0].get_bodies.body);
          this.formBodies = body[0].fields;
          this.formResponses = res.data.formResponses;
          //  
          this.company_name = res.data.company.company_name;
        })
        .catch((error) => {
          
        })
        .finally(() => {
          this.preloader = false;
        });
    },
  },
  mounted() {
    // let myLocation = location.href;
    // let split = myLocation.split("/");
    
    // let id = split[6].split("?")[0];
    let id = this.$attrs['props'].id;
    this.getBodies(id);
  },
};
</script>
